import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getBalanceLookupDialog } from '../Selectors'
import { setBalanceLookupDialogOptions } from '../ActionCreators'
import ConfirmModalV2 from '../../components/ConfirmModalV2'
import { APPLICATION_STRINGS } from '../../strings'
import { sendCFDScreenNav } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'

export const VNBalanceLookupDialog = () => {
  const dispatch = useDispatch()
  const dialogOptions = useSelector((state) => getBalanceLookupDialog(state))

  if (dialogOptions?.get('open')) {
    return (
      <ConfirmModalV2
        onButtonTwoClick={() => {
          dispatch(setBalanceLookupDialogOptions({ open: false, amount: '' }))

          if (dialogOptions?.get('previousScreen')) {
            sendCFDScreenNav(dialogOptions?.get('previousScreen'))
          }
        }}
        headerText={dialogOptions?.get('amount')}
        subtext={APPLICATION_STRINGS.AVAILABLE_BALANCE_LOOKUP_SUBTEXT}
        buttonTwoText={APPLICATION_STRINGS.OKAY_BUTTON_TEXT}
        singleButtonOnly={true}
      />
    )
  }
}
